export default {
  en: {
    title: 'NPS (Net Promoter Score)',
    subtitle: 'NPS of calls',
    type: {
      detractors: 'Detractors',
      passive: 'Passives',
      promoters: 'Promoters',
    },
    filters: {
      title: 'Filters',
      subtitle: 'Filter NPS by segment or agent.',
      department: {
        all: 'All segments',
      },
      agent: {
        all: 'All agents',
      },
    },
  },
  es: {
    title: 'NPS (Net Promoter Score)',
    subtitle: 'NPS de las llamadas',
    type: {
      detractors: 'Detractores',
      passive: 'Pasivos',
      promoters: 'Promotores',
    },
    filters: {
      title: 'Filtros',
      subtitle: 'Filtre NPS por segmento o agente.',
      department: {
        all: 'Todos los segmentos',
      },
      agent: {
        all: 'Todos los agentes',
      },
    },
  },
  fr: {
    title: 'NPS (Net Promoter Score)',
    subtitle: 'NPS des appels',
    type: {
      detractors: 'Détracteurs',
      passive: 'Passifs',
      promoters: 'Promoteurs',
    },
    filters: {
      title: 'Filtres',
      subtitle: 'Filtrer le NPS par segment ou agent.',
      department: {
        all: 'Tous les segments',
      },
      agent: {
        all: 'Tous les agents',
      },
    },
}

};
